import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import Subtitle from '../Typography/SubTitle';

const labelPropertyTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

type LabelProperties = InferProps<typeof labelPropertyTypes>;

const StyledSubtitle = styled(Subtitle)`
  && {
    position: absolute;
    bottom: 0;
    margin: 0;
    min-width: 147px;
    height: 23px;
    text-align: center;
    text-transform: uppercase;
    color: var(--white);
    background-color: var(--primary-color);

    span {
      padding: 0 8px;
    }
  }
`;

const Label = (
  {
    children,
    className,
  }: LabelProperties,
) => (
  <StyledSubtitle
    tag="p"
    className={className}
  >
    <span>{children}</span>
  </StyledSubtitle>
);

Label.propTypes = {
  /** Sets the content */
  children: PropTypes.node,
  /** Sets the class name */
  className: PropTypes.string,
  /** Sets a predefined style for headers */
};

export default Label;
